// common business logic related util methods
import axios from "axios";
import { baseUri } from "../../config/config";
import { enqueueSnackbar } from "notistack";
import { HandlePathNavigate } from "../Constant";
axios.defaults.headers.post["Content-Type"] = "application/json";

export async function invokeApi({
  path,
  method = "GET",
  headers = {},
  queryParams = {},
  postData = {},
  isCompletePath = false,
}) {
  const reqObj = {
    method,
    url: isCompletePath ? path : baseUri + path,
    headers,
  };

  reqObj.params = queryParams;

  if (method === "POST") {
    reqObj.data = postData;
  }
  if (method === "PUT") {
    reqObj.data = postData;
  }
  if (method === "DELETE") {
    reqObj.data = postData;
  }

  let results;
  if (postData instanceof FormData) {
    console.info(...postData, "<===REQUEST-DATA===>");
    reqObj.headers["Content-Type"] = "multipart/form-data";
  }
  console.info("<===REQUEST-OBJECT===>", reqObj);

  try {
    results = await axios(reqObj);
    console.info("<===Api-Success-Result===>", results);

    return results.data;
  } catch (error) {
    console.info(
      error.request.responseURL,
      "<===Api-Error===>",
      error.response.data
    );

    if (error.response.status === 401) {
      HandlePathNavigate("/validate-profile");
      return {
        code: 401,
        message: error.response.data.message
          ? error.response.data.message
          : "Unauthorized. Please login again.",
      };
    } else {
      return {
        code: error.response.status,
        message: error.response.data.message ? error.response.data.message : "",
      };
    }
  }
}
